export default __webpack_public_path__ + "static/media/fw-emily-er-Yellow Gold.774c2208.mp4";